/** @format */

import React from 'react'

import moment from 'moment'

import { Card, Tag, Spin, Typography, Layout, Row, Col, Avatar, Space } from 'antd'
import {
	UserOutlined,
	MailOutlined,
	UserAddOutlined,
	FileTextOutlined,
	PhoneOutlined,
	ClockCircleOutlined,
} from '@ant-design/icons'

import './style.css'

export default function UserInfo(props) {
	if (props.infoProfile) {
		return (
			<Card className='ph-profile-main-container'>
				<Layout className='ph-profile-container'>
					<Row>
						<Col xs={24} sm={10} md={10} lg={14} xl={14}>
							<Row className='ph-profile-main-info-container'>
								<Col
									xs={4}
									sm={4}
									md={4}
									lg={4}
									xl={4}
									className='ph-profile-main-info-inner-container'>
									<Avatar className='ph-profile-avatar' icon={<UserOutlined />} />
								</Col>
								<Col
									xs={20}
									sm={20}
									md={20}
									lg={20}
									xl={20}
									className='ph-profile-main-info-inner-container-2'>
									<Space direction='vertical'>
										<Typography.Text className='ph-profile-main-title-user'>
											{props.infoProfile.first_name} {props.infoProfile.last_name}
										</Typography.Text>
										<Space>
											<Typography.Text className='ph-profile-main-role-user'>
												Roles:&nbsp;&nbsp;
												{props.infoProfile?.roles?.map((rol, index) => (
													<Tag className='ph-profile-role-tag' key={index} color='#2c73b3'>
														{rol}
													</Tag> 
												))}
											</Typography.Text>
										</Space>
										{/* <Space>
											<Typography.Text className='ph-profile-role-title'>
												{' '}
												Rol Farmaceútico:
											</Typography.Text>
											<Typography.Text className='ph-profile-role-description'>
												{props.infoProfile.rol_qf}
											</Typography.Text>
										</Space>
										<Space>
											<Typography.Text className='ph-profile-role-title'>
												Rol Tracking:
											</Typography.Text>
											<Typography.Text className='ph-profile-role-description'>
												{props.infoProfile.rol_tracking}
											</Typography.Text>
										</Space> */}
									</Space>
								</Col>
							</Row>
						</Col>
						<Col xs={24} sm={14} md={14} lg={10} xl={10} className='ph-profile-info-container'>
							<Space direction='vertical'>
								<Space direction='horizontal'>
									<MailOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'>Nombre: </Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{props.infoProfile.first_name}
									</Typography.Text>
								</Space>
								<Space direction='horizontal'>
									<UserOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'>Apellido: </Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{props.infoProfile.last_name}
									</Typography.Text>
								</Space>
								<Space direction='horizontal'>
									<UserAddOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'>Correo: </Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{props.infoProfile.email}
									</Typography.Text>
								</Space>
								<Space direction='horizontal'>
									<FileTextOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'>
										Identificación:{' '}
									</Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{props.infoProfile.rut}
									</Typography.Text>
								</Space>
								<Space direction='horizontal'>
									<PhoneOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'> Teléfono: </Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{props.infoProfile.phone}
									</Typography.Text>
								</Space>
								<Space direction='horizontal'>
									<ClockCircleOutlined className='ph-profile-info-icon' />
									<Typography.Text className='ph-profile-info-title'>Fecha: </Typography.Text>
									<Typography.Text className='ph-profile-info-description'>
										{moment(props.infoProfile.createdAt).format('DD/MM/YYYY HH:mm:ss')}
									</Typography.Text>
								</Space>
							</Space>
						</Col>
					</Row>
				</Layout>
			</Card>
		)
	} else {
		return <Spin />
	}
}
